export { default } from './SectionStrategies';